import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useQuasar } from 'quasar';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const dark = process.env.THEME === 'dark';
if (dark) {
  const $q = useQuasar();
  $q.dark.set(true);
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})